// Convertit un SVG (quelle que soit son origine) en PNG, en essayant plusieurs stratégies pour déterminer ses dimensions réelles, dans
// l'ordre du plus fiable au plus spécifique :
// 1. viewBox de la première balise <svg> — le plus répandu et robuste, fonctionne même si le SVG n'a pas de width/height propres.
// 2. width/height en dur sur une balise <svg> — utile pour les SVG à l'ancienne" sans viewBox (ex: SVG imbriqué généré par D2).
// 3. Taille intrinsèque renvoyée par le navigateur une fois l'image chargée
export const convertSvgToPng = (svgString: string, fileName: string, maxDimension = 3072, desiredScale = 1): Promise<File> => {
  return new Promise((resolve, reject) => {
    let svgWidth: number | undefined;
    let svgHeight: number | undefined;

    // 1. viewBox de la première balise <svg> rencontrée
    const viewBoxMatch = svgString.match(/viewBox=["']([\d.-]+)\s+([\d.-]+)\s+([\d.-]+)\s+([\d.-]+)["']/);
    if (viewBoxMatch) {
      svgWidth = parseFloat(viewBoxMatch[3]);
      svgHeight = parseFloat(viewBoxMatch[4]);
    }

    // 2. Repli sur width/height en dur si pas de viewBox exploitable
    if (!svgWidth || !svgHeight) {
      const dimensionsMatch = svgString.match(/<svg[^>]*\swidth="([\d.]+)"[^>]*\sheight="([\d.]+)"/);
      if (dimensionsMatch) {
        svgWidth = parseFloat(dimensionsMatch[1]);
        svgHeight = parseFloat(dimensionsMatch[2]);
      }
    }

    const img = new Image();
    const svgBlob = new Blob([svgString], {type: 'image/svg+xml'});
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      // 3. Dernier recours : taille intrinsèque renvoyée par le navigateur
      if (!svgWidth || !svgHeight) {
        svgWidth = img.naturalWidth || img.width;
        svgHeight = img.naturalHeight || img.height;
      }

      if (!svgWidth || !svgHeight) {
        URL.revokeObjectURL(url);
        reject(new Error('Could not determine SVG dimensions'));
        return;
      }

      const largestDimension = Math.max(svgWidth, svgHeight);
      const exportScale = Math.min(desiredScale, maxDimension / largestDimension);

      const canvas = document.createElement('canvas');
      canvas.width = Math.round(svgWidth * exportScale);
      canvas.height = Math.round(svgHeight * exportScale);
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        URL.revokeObjectURL(url);
        reject(new Error('Canvas context unavailable'));
        return;
      }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(url);
        if (!blob) {
          reject(new Error('PNG conversion failed'));
          return;
        }
        resolve(new File([blob], fileName, {type: 'image/png'}));
      }, 'image/png');
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('SVG load failed'));
    };
    img.src = url;
  });
};
